import { useCallback, useState } from "react";
import api from "../services/api";

const SESSION_KEY = "auth_session";

function saveSession(data) {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
  } catch {
    // sessionStorage pode estar desativado
  }
}

function loadSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function clearSession() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // ignora
  }
}

function buildInitialState() {
  const saved = loadSession();
  if (!saved) return { student: null, adminLogged: false };
  return {
    student: saved.tipo === "aluno" ? saved.data : null,
    adminLogged: saved.tipo === "admin",
  };
}

export function useAuth() {
  const initial = buildInitialState();
  const [student, setStudent] = useState(initial.student);
  const [adminLogged, setAdminLogged] = useState(initial.adminLogged);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loginAluno = useCallback(async (usuario, senha) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.post("/auth/login", { usuario, senha });
      const studentData = data.data;
      setStudent(studentData);
      saveSession({ tipo: "aluno", data: studentData });
      return { ok: true, student: studentData };
    } catch (err) {
      const msg =
        err.response?.data?.message || "Não foi possível conectar ao servidor.";
      setError(msg);
      return { ok: false, error: msg };
    } finally {
      setLoading(false);
    }
  }, []);

  const loginAdmin = useCallback(async (usuario, senha) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.post("/auth/admin", { usuario, senha });
      setAdminLogged(true);
      saveSession({ tipo: "admin", data: data.data });
      return { ok: true };
    } catch (err) {
      const msg =
        err.response?.data?.message || "Não foi possível conectar ao servidor.";
      setError(msg);
      return { ok: false, error: msg };
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    setStudent(null);
    setAdminLogged(false);
    clearSession();
  }, []);

  return {
    student,
    setStudent,
    adminLogged,
    setAdminLogged,
    loading,
    error,
    setError,
    loginAluno,
    loginAdmin,
    logout,
  };
}
